import { useCallback } from "react";
import { useLocation } from "react-router";
import { EventService } from "@perxis-auto/shared";
import "../../../shared/config/env.js";
import { APP_EVENTS, APP_EVENT_BUTTON_IDS } from "../../../shared/config/events.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { selectors } from "../model/index.js";
import { actions } from "../model/slice.js";
function useFavorite(vehicleItem) {
  const dispatch = useAppDispatch();
  const eventService = EventService.getInstance();
  const { pathname } = useLocation();
  const vehicleId = vehicleItem == null ? void 0 : vehicleItem.id;
  const favoriteItem = useAppSelector((state) => {
    if (!vehicleId) {
      return;
    }
    const favoriteItem2 = selectors.selectById(state.favorite, vehicleId);
    return favoriteItem2;
  });
  const toggle = useCallback(() => {
    if (!vehicleId) {
      return;
    }
    if (favoriteItem) {
      dispatch(actions.removeItem(vehicleId));
      eventService.sendEvent(APP_EVENTS.ButtonClicked, {
        id: APP_EVENT_BUTTON_IDS.REMOVE_FROM_FAVORITES,
        data: vehicleItem,
        path: pathname
      });
    } else {
      dispatch(
        actions.addItem({
          id: vehicleId,
          addedBy: +/* @__PURE__ */ new Date()
        })
      );
      eventService.sendEvent(APP_EVENTS.ButtonClicked, {
        id: APP_EVENT_BUTTON_IDS.ADD_TO_FAVORITES,
        data: vehicleItem,
        path: pathname
      });
    }
  }, [vehicleId, favoriteItem, dispatch, vehicleItem, pathname]);
  return [!!favoriteItem, toggle];
}
export {
  useFavorite
};
